// --- React COmponent: ClientDetails.jsx
// -- Will share the Contents for invoice tab later
// -- for documents. just add a component similar like employee self service document component
// -- contact details..show full address and contact information

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClientAttachmentUpload from "../../components/client/ClientAttachmentUpload";
import ClientContacts from "../../components/client/ClientContacts";
import API_BASE_URL from "../../config/api";

export default function ClientDetails({ }) {
  const [activeTab, setActiveTab] = useState("overview");
  const [client, setClient] = useState(null);
  const token = sessionStorage.getItem("token");
  const { id } = useParams();
  const employeeId = sessionStorage.getItem("employeeId");

  useEffect(() => {
    async function fetchClient() {
      try {
        const res = await fetch(`${API_BASE_URL}/api/clients/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) throw new Error("Failed to fetch client");
        const data = await res.json();
        setClient(data);
      } catch (err) {
        console.error(err);
      }
    }
    fetchClient();
  }, [id, token]);

  if (!client) return <div className="p-4">Loading...</div>;

  return (
    <div>
      {/* breadcrumb */}
      <div className="flex flex-wrap gap-2 p-4">
        <a className="text-[#60758a] text-base font-medium leading-normal" href="/app/clientslist">
          Clients
        </a>
        <span className="text-[#60758a] text-base font-medium leading-normal">/</span>
        <span className="text-[#111418] text-base font-medium leading-normal">
          {client.clientName}
        </span>
      </div>

      {/* header */}
      <div className="flex flex-wrap justify-between gap-3 p-4">
        <div className="flex min-w-72 flex-col gap-3">
          <p className="text-[#111418] tracking-light text-[32px] font-bold leading-tight">
            {client.clientName}
          </p>
          <p className="text-[#60758a] text-sm font-normal leading-normal">
            {client.industryName}
          </p>
        </div>
      </div>

      {/* tabs */}
      <div className="pb-3">
        <div className="flex border-b border-[#dbe0e6] px-4 gap-8">
          {["overview", "documents", "invoices", "contacts"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex flex-col items-center justify-center border-b-[3px] pb-[13px] pt-4 ${activeTab === tab
                ? "border-b-[#111418] text-[#111418]"
                : "border-b-transparent text-[#60758a]"
                }`}
            >
              <p className="text-sm font-bold leading-normal tracking-[0.015em] capitalize">
                {tab}
              </p>
            </button>
          ))}
        </div>
      </div>

      {activeTab === "overview" && (
        <>
          <h2 className="text-[#111418] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">
            Company Details
          </h2>
          <div className="p-4 grid grid-cols-[20%_1fr] gap-x-6">
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">
                Website
              </p>
              {client.website ? (
                <a
                  href={client.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit text-blue-600 text-sm font-normal leading-normal hover:underline"
                >
                  {client.website}
                </a>
              ) : (
                <span className="w-fit text-gray-500 text-sm font-normal leading-normal">-</span>
              )}

            </div>
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">
                Industry
              </p>
              <p className="text-[#111418] text-sm font-normal leading-normal">
                {client.industryName && client.industryName.trim() !== "" ? client.industryName : "-"}
              </p>
            </div>
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">
                Location
              </p>
              <p className="text-[#111418] text-sm font-normal leading-normal">
                {client.location && client.location.trim() !== "" ? client.location : "-"}
              </p>
            </div>
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">
                GSTIN
              </p>
              <p className="text-[#111418] text-sm font-normal leading-normal">
                {client.gstin && client.gstin.trim() !== "" ? client.gstin : "-"}
              </p>
            </div>
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">PAN</p>
              <p className="text-[#111418] text-sm font-normal leading-normal">
                {client.pan && client.pan.trim() !== "" ? client.pan : "-"}
              </p>
            </div>
            <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
              <p className="text-[#60758a] text-sm font-normal leading-normal">
                Status
              </p>
              <p className="text-[#111418] text-sm font-normal leading-normal">
                {client.status ? "Active" : "Inactive"}
              </p>
            </div>
          </div>
        </>
      )}

      {activeTab === "documents" && (
        <div className="p-4">
          <ClientAttachmentUpload userId={client.id} uploadedBy={employeeId} />
        </div>
      )}
      {activeTab === "invoices" && (
        <div className="p-4">Invoices Section</div>
      )}
      {activeTab === "contacts" && (
        <div className="p-4">
          <ClientContacts client={client} />
        </div>
      )}
    </div>
  );
}
